//import React from 'react';

import RNDropzone from 'react-dropzone'; // only for web ?
import FileSaver from 'file-saver';

/*
import { 
  VictoryChart, 
  VictoryGroup, 
  VictoryArea, 
  VictoryPolarAxis, 
  VictoryLabel,
  VictoryLine, 
  VictoryAxis, 
  VictoryScatter, 
} from 'victory'; // react の場合
//} from 'victory-native'; // react-native の場合 install react-native-svg の事前実行が必要
*/
import * as Victory from 'victory';

export class df { // environment dependent function

  static Dzn = RNDropzone;

  static Vry = Victory;

  static myFL_ept(pd={ // export file, only for web
    fileName: '',
    val: '',
  }) {
//    let _blob = new Blob([pd.val], {type: "text/plain;charset=utf-8"});
    let _bom = new Uint8Array([0xEF, 0xBB, 0xBF]);
    let _blob = new Blob([_bom, pd.val], {type: "text/plain;charset=utf-8"});
//    let _blob = new Blob([_bom, pd.val], {type: "text/csv;charset=utf-8"});
//    let _blob = new Blob([_bom, pd.val], {type: "application/vnd.ms-excel;charset=utf-8"});
    FileSaver.saveAs(_blob, pd.fileName);
  };

/*
  static FileMdl(pd) { // File Inport 用のモーダル
    return (
      <ce.Mdl
        key={-1}
        mdlType={'file'}
      >
        <df.Dzn
          key={-1}
          onDrop={ _lo_files => {
            global.c?.setState({
              sgcd_mdls: bf.p(global.c?.state.sgcd_mdls, _next =>{
                _next.file.b_showMdl = false;
              }),
            }, () => {
              _lo_files.map(_o_file => {
                bf.myFL_read({
                  mode: global.c?.state.sgcd_mdls?.file?.mode, 
                  o_file: _o_file
                })
                .then( _r => {
                  if (global.c?.state.sgcd_mdls?.file?.onRead) {
                    global.c?.state.sgcd_mdls.file.onRead(_r);
                  };
                });
              });
            });
          }}
          multiple={true}
        >
          {({ getRootProps, getInputProps }) => {
            return (
              <div
                {...getRootProps()}
                style={{
                  height: ic.gn_fontSizeNrm * 5 + ic.gn_mgnNrm * 2,
                  width: ic.gn_mdlW - ic.gn_mgnNrm * 3,
                  borderWidth: ic.gn_bdrWNrm,
                  borderStyle: 'dashed',
                  borderColor: '#E0E0E0',
                  marginTop: ic.gn_mgnNrm,
                  marginBottom: ic.gn_mgnNrm,
                  marginLeft: ic.gn_mgnNrm,
                  marginRight: ic.gn_mgnNrm,
                  paddingTop: 'auto',
                  paddingBottom: 'auto',
                  paddingLeft: 'auto',
                  paddingRight: 'auto',
                  flexDirecton: 'center',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <input
                  {...getInputProps()}
                />
                <p>click or drop files here</p>
              </div>
            );
          }}
        </df.Dzn>
      </ce.Mdl>
    );
  };
*/

}
